/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Visualize_Forest_Result_ContentInputs */

const en_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track your growth`)
};

const ar_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتبع نموك`)
};

const de_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgen Sie Ihr Wachstum`)
};

const es_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue tu crecimiento`)
};

const fr_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez votre croissance`)
};

const it_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia la tua crescita`)
};

const ja_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成長を追跡する`)
};

const ko_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성장 추적하기`)
};

const pt_br_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitore seu crescimento`)
};

const ru_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживайте свой рост`)
};

const th_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตามการเติบโตของคุณ`)
};

const tr_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büyümeni takip et`)
};

const zh_cn_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感受成果`)
};

const zh_tw_walkturough_visualize_forest_result_content = /** @type {(inputs: Walkturough_Visualize_Forest_Result_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感受成果`)
};

/**
* | output |
* | --- |
* | "Track your growth" |
*
* @param {Walkturough_Visualize_Forest_Result_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_visualize_forest_result_content = /** @type {((inputs?: Walkturough_Visualize_Forest_Result_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Visualize_Forest_Result_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_visualize_forest_result_content(inputs)
	if (locale === "ar") return ar_walkturough_visualize_forest_result_content(inputs)
	if (locale === "de") return de_walkturough_visualize_forest_result_content(inputs)
	if (locale === "es") return es_walkturough_visualize_forest_result_content(inputs)
	if (locale === "fr") return fr_walkturough_visualize_forest_result_content(inputs)
	if (locale === "it") return it_walkturough_visualize_forest_result_content(inputs)
	if (locale === "ja") return ja_walkturough_visualize_forest_result_content(inputs)
	if (locale === "ko") return ko_walkturough_visualize_forest_result_content(inputs)
	if (locale === "pt_br") return pt_br_walkturough_visualize_forest_result_content(inputs)
	if (locale === "ru") return ru_walkturough_visualize_forest_result_content(inputs)
	if (locale === "th") return th_walkturough_visualize_forest_result_content(inputs)
	if (locale === "tr") return tr_walkturough_visualize_forest_result_content(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_visualize_forest_result_content(inputs)
	return zh_tw_walkturough_visualize_forest_result_content(inputs)
});